import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { RouterLink } from '@/components/functional/Link/RouterLink';
import { TopNewsSlider } from '@/components/modules/pages/top/slider/TopNewsSlider';
import { AngleRightIcon } from '@/components/ui/SvgIcon/Variable/SvgIconComponents';
import { LinkText } from '@/components/ui/Typography/Body/LinkText';
import { Text } from '@/components/ui/Typography/Body/Text';
import { IconTextGroup } from '@/components/ui/Typography/IconText/IconTextGroup';
import { releaseListPath, releaseOnePath } from '@/utils/router/links';
/**
 * TOPページの ニュース
 * @param props
 * @returns
 */
export const TopNews = (props) => {
    const { className = '', newsList } = props;
    /** お知らせデータ整形 */
    const items = useMemo(() => newsList
        .filter((item) => item.file !== null || item.detail_id !== null)
        .map((item) => ({
        date: item.display_from_at,
        hasFile: !!item.file && item.detail_id === null,
        id: item.id,
        linkTo: !!item.file && item.detail_id === null
            ? item.file.url
            : releaseOnePath(`${item.detail_id}`),
        title: item.title,
    })), [newsList]);
    return (_jsxs("div", Object.assign({ className: clsx('w-full', 'relative', 'bg-gray-50', className) }, { children: [_jsx(Text, Object.assign({ className: clsx('absolute top-0 left-0', 'w-[60px] lg:w-[160px] h-full', 'inline-flex items-center justify-center', 'text-[14px] lg:text-[24px] leading-[1.5]', 'bg-turquoise-blue-100'), color: 'white', fontFamily: 'alpha', size: 'none' }, { children: "News" })), _jsxs("div", Object.assign({ className: clsx('relative', 'pt-16 pr-16 pb-60 pl-80 lg:pt-[34px] lg:pb-32 lg:pr-[200px] lg:pl-[192px]', 'w-full') }, { children: [_jsx(TopNewsSlider, { items: items }), _jsx("div", Object.assign({ className: clsx('inline-block', 'absolute bottom-20 right-16 lg:bottom-auto lg:top-36 lg:right-64') }, { children: _jsx(RouterLink, Object.assign({ className: 'group', to: releaseListPath() }, { children: _jsxs(IconTextGroup, Object.assign({ className: 'justify-center', isInline: true }, { children: [_jsx(LinkText, Object.assign({ isGroup: true, size: 'md' }, { children: "\u30CB\u30E5\u30FC\u30B9\u4E00\u89A7\u3078" })), _jsx(AngleRightIcon, { color: 'info', size: 'sm' })] })) })) }))] }))] })));
};
